import developers from "../developers";
import tags from "../tags";

// icons
import toolsIcon from "../../assets/apps/icons/tools.png";

// images
import toolsCover from "../../assets/apps/images/tools/cover.png";
import toolsImage1 from "../../assets/apps/images/tools/1.png";
import toolsImage2 from "../../assets/apps/images/tools/2.png";
import toolsImage3 from "../../assets/apps/images/tools/3.png";
import toolsImage4 from "../../assets/apps/images/tools/4.png";
import toolsImage5 from "../../assets/apps/images/tools/5.png";
import toolsImage6 from "../../assets/apps/images/tools/6.png";
import toolsImage7 from "../../assets/apps/images/tools/7.png";

const tools = {
    title: "Quick Tools",
    slug: "quick-tools",
    url: "https://tools.bilalabdulhadi.com",
    description: `
### Overview
Quick Tools is a modern and responsive web application that brings together a growing collection of lightweight utilities designed to simplify everyday digital tasks. It provides instant access to helpful tools directly in the browser, eliminating the need for installing extra software or searching for separate solutions online.

### Purpose & Value
The main goal of Quick Tools is to boost productivity by offering practical features that developers, students, and everyday users frequently need. Whether it's formatting content, generating useful outputs, or handling repetitive workflows, the platform is built to make tasks faster, smoother, and more efficient.

### User Experience & Design
Quick Tools focuses heavily on clean design, accessibility, and usability. With a sleek interface, responsive layout, and smooth interactions, the experience feels modern and intuitive across all devices — from desktops to mobile screens.

### Key Features
- A collection of fast and easy-to-use browser-based tools  
- Modern UI built with React and Material UI  
- Responsive design optimized for different screen sizes  
- Developer-friendly structure that supports scalability and future expansion  
- Smooth navigation and organized categories for quick discovery  

---

### Available Tools Collection

Quick Tools includes a wide variety of utilities across different categories, making it a complete productivity toolkit:

#### General Utilities
- Basic Calculator  
- Age Calculator  
- BMI Calculator  
- Notes Tool  

#### Text & Writing Tools
- Text Counter  
- Space Remover  
- Text Reverser  
- Palindrome Checker  

#### Password & Content Generators
- Password Generator  
- Password Strength Checker  
- Lorem Ipsum Generator  

#### Fun & Interactive Tools
- Random Draw  
- Rock Paper Scissors  

#### Statistics & Calculations
- Mean Calculator  
- Median Calculator  
- Mode Calculator  
- Greatest Common Divisor (GCD)  
- Least Common Multiple (LCM)  
- Prime Number Checker  

#### Number System Converters
- Binary Converter  
- Octal Converter  
- Decimal Converter  
- Hexadecimal Converter  


#### Color Conversion Tools
- HEX Converter  
- RGB Converter  
- HSL Converter  

#### Unit Conversion Tools

Quick Tools also provides powerful unit converters across multiple measurement types:

- Length Converter  
- Weight Converter  
- Volume Converter  
- Temperature Converter  
- Speed Converter  
- Time Converter  
- Data Converter  
- Energy Converter  
- Pressure Converter  
- Area Converter  


### Text Case Conversion Tools

A complete suite of text transformation utilities is included:

- Uppercase  
- Lowercase  
- Capitalize  
- Title Case  
- Sentence Case  
- Toggle Case  
- Camel Case  
- Pascal Case  
- Snake Case  
- Screaming Snake Case  
- Kebab Case  
- Train Case  
- Dot Case  
- Path Case  
- Cobol Case  

---

### Open Source & Future Growth
Quick Tools is an open-source project, making it both a practical toolbox and a learning resource for developers. The platform is designed to grow over time, allowing more tools and features to be added seamlessly while maintaining simplicity and performance.

### Summary
Quick Tools is more than just a set of utilities — it is a productivity-focused toolkit built with modern web technologies, delivering elegant design, fast performance, and real value through a growing collection of tools that save time and enhance daily workflows.
`,
    tags: [
        tags.react,
        tags.javascript,

        tags.mui,
        tags.bootstrap,

        tags.utility,
        tags.productivity,

        tags.responsive,
        tags.mobileFirst,
        tags.darkMode,

        tags.webApp,
    ],
    icon: toolsIcon,
    cover: toolsCover,
    badge: "React",
    images: [
        toolsImage1,
        toolsImage2,
        toolsImage3,
        toolsImage4,
        toolsImage5,
        toolsImage6,
        toolsImage7,
    ],
    github: "https://github.com/bilalabdulhadii/react-quick-tools",
    developer: developers.bilalabdulhadii,
};

export default tools;
